import React from "react";
import { CountryDropdown } from "react-country-region-selector";
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore.js";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const CountryField = ({ label, value, error, name, handleChange }) => {
  const { country_code } = useProductData();
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  if (country_code) {
    return (
      <div className={s.inputContainer} style={{ width: "100%" }}>
        <div
          className={cn(
            s.input,
            error && s.input__error,
            isEnhancedContrast && s.enhancedContrast,
            isEnhancedContrast && error && s.enhancedContrast__error
          )}
        >
          {label && (
            <span
              className={cn(
                s.styledLabel,
                s.styledLabel__active,
                isEnhancedContrast && s.styledLabel__enhancedContrast
              )}
            >
              {label}
            </span>
          )}
          <div className={s.input__customSelect}>
            <CountryDropdown
              id="country"
              valueType="short"
              labelType="full"
              value={value?.toUpperCase() || country_code}
              classes={cn(s.input__select, s.overflowedSelect, isEnhancedContrast && s.enhancedContrast)}
              autoComplete="country-name"
              name={name}
              onChange={(value) => {
                handleChange(value);
              }}
            />
          </div>
        </div>
        {error && (
          <div className="formError" style={{ marginTop: "4px" }}>
            {error}
          </div>
        )}
      </div>
    );
  }
};

export default CountryField;
